import Vue from "vue";
import Vuex from "vuex";

import authentication from "./modules/authentication";
import project from "./modules/project";
import annotation from "./modules/annotation";
import slides from "./modules/slides";
import annotationClass from "@/store/modules/annotationClass";
import user from "@/store/modules/user";
import imagingStudy from "@/store/modules/imagingStudy";
import status from "@/store/modules/status";
import fhir from "@/store/modules/fhir";
import contributions from "@/store/modules/contributions";
import service from "@/store/modules/service";
import diagnosis from "@/store/modules/diagnosis";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    authentication,
    project,
    annotation,
    slides,
    annotationClass,
    user,
    imagingStudy,
    status,
    fhir,
    contributions,
    service,
    diagnosis
  }
});
